<template>
  <div>
    <v-sheet class="py-3 py-md-6" color="primary">
      <TitleWidget dark>
        {{ title }}
      </TitleWidget>
    </v-sheet>

    <v-container class="pb-10 pb-md-13 pb-lg-16 item">
      <v-sheet color="transparent" class="mt-6 mt-md-8 mx-auto" max-width="500">
        <ContactForm :action="server + formAction" :response-to="responseTo" />
      </v-sheet>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import ContactForm from "../components/forms/ContactForm.vue";

const _data = {
  title: "Fale Conosco",
  formAction: "/rest/email/contact-us",
  responseTo: "/contato/obrigado",
};

export default {
  data: () => ({
    ..._data,
  }),
  components: {
    TitleWidget,
    ContactForm,
  },
};
</script>
